// Translates between the brands API wire format and the shape the UI renders.
//
// The API mixes conventions: `organizationId`/`brandId` are camelCase while the
// presentation fields are snake_case (`is_default`, `color_primary`). The UI was
// built against a mockup that used `id`/`isDefault`/`colorPrimary`, so the
// mapping lives here instead of being repeated in every component.
//
// `initials` is presentation-only: the API does not store it, so it is derived
// from the brand name.

/** First letter of the first two words, e.g. "Reformas Express" -> "RE". */
export const brandInitials = name => {
  if (!name) return ""
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map(word => word.charAt(0).toUpperCase())
    .join("")
}

/** API BrandOut -> UI brand. */
export const brandFromApi = brand => ({
  id: brand.brandId,
  organizationId: brand.organizationId,
  name: brand.name,
  isDefault: brand.is_default,
  logo: brand.logo,
  colorPrimary: brand.color_primary,
  colorSecondary: brand.color_secondary,
  cover: brand.cover,
  coverFields: brand.cover_fields,
  signature: brand.signature,
  conditions: brand.conditions,
  initials: brandInitials(brand.name),
})

export const brandsFromApi = brands =>
  Array.isArray(brands) ? brands.map(brandFromApi) : []

// UI brand -> API body. Only defined keys are sent so PATCH stays partial.
//
// Absences are deliberate: cif_number/address/email/phone/website belong to the
// account and the API rejects them with a 422, and is_default only moves
// through the dedicated set-default endpoint.
const WIRE_KEYS = {
  name: "name",
  logo: "logo",
  colorPrimary: "color_primary",
  colorSecondary: "color_secondary",
  cover: "cover",
  coverFields: "cover_fields",
  signature: "signature",
  conditions: "conditions",
}

export const brandToApi = brand => {
  const body = {}
  Object.entries(WIRE_KEYS).forEach(([uiKey, wireKey]) => {
    if (brand?.[uiKey] !== undefined) body[wireKey] = brand[uiKey]
  })
  return body
}
